import { Col, Menu, Row } from "antd";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useOutletContext } from "react-router";
import { IEnvDetails } from "../../types";

export default function EnvironmentSettingsRoot() {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState("general");
    const { envDetails } = useOutletContext<{ envDetails: IEnvDetails }>();

    useEffect(() => {
        setActiveTab(location.pathname.split("/")[6] || "general");
    }, [location.pathname]);

    return (
        <Row gutter={24}>
            <Col span={6}>
                <Menu
                    mode="inline"
                    className="ant-card-bordered"
                    selectedKeys={[activeTab]}
                    onSelect={(item) => {
                        navigate(item.key);
                        setActiveTab(item.key);
                    }}
                >
                    <Menu.Item key="general">General</Menu.Item>
                    <Menu.Item key="infrastructure">Infrastructure</Menu.Item>
                    {/* <Menu.Item key="deployments">Deployments</Menu.Item> */}
                </Menu>
            </Col>
            <Col span={18}>
                <Outlet context={{ envDetails }} />
            </Col>
        </Row >
    );

}